import React, { useEffect, useState, useRef } from "react";
import Header from "../../../header/header";
import Footer from "../../../footer/footer";
import Sidebar from "../../../Sidebar/Sidebar";
import { getOrderDetails, getOrderOrderDetailsOnID } from "../../service";
import Skeleton from "../../component/skeleton";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { IMAGES } from "../../../../../assets/images";

const Orders = () => {
  const invoiceRef = useRef(null);

  const [orderList, setorderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [OrderDetailsOnID, setOrderDetailsOnID] = useState({});

  useEffect(() => {
    getOrderList();
  }, []);

  const getOrderList = async () => {
    try {
      const res = await getOrderDetails({ cat_id: "" });
      await setorderList(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getOrderDetailsOnID = async (id) => {
    try {
      const res = await getOrderOrderDetailsOnID(id);
      setOrderDetailsOnID({ ...res });
      console.log(res);
      console.log(OrderDetailsOnID);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGenerateInvoice = async (id) => {
    console.log("hey man", id);
    await getOrderDetailsOnID(id);
    console.log(OrderDetailsOnID);
    setLoading2(true);
  };

  useEffect(() => {
    if (
      loading2 &&
      OrderDetailsOnID &&
      Object.keys(OrderDetailsOnID).length > 0
    ) {
      downloadInvoice();
      setLoading2(false);
    }
  }, [OrderDetailsOnID]);

  const downloadInvoice = async () => {
    console.log(OrderDetailsOnID);
    console.log("qwertyu", invoiceRef.current);
    if (!invoiceRef.current) {
      console.error("Invoice element not found!");
      return;
    }

    try {
      const canvas = await html2canvas(invoiceRef.current, { scale: 1.5 });
      const imgData = canvas.toDataURL("image/jpeg", 0.85);

      // Debugging: Check the imgData
      console.log("Generated image data:", imgData);

      if (!imgData) {
        throw new Error("Failed to generate image from canvas");
      }

      const pdf = new jsPDF("p", "mm", "a4");

      // Calculate image dimensions for PDF
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Order Invoice.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }

    // try {
    //     const canvas = await html2canvas(invoiceRef.current);
    //     console.log(canvas);
    //     const imgData = canvas.toDataURL('image/png');

    //     if (!imgData) {
    //         throw new Error('Failed to generate image from canvas');
    //     }

    //     const link = document.createElement('a');
    //     link.href = imgData;
    //     link.download = 'Order Invoice.png';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     console.log('Image downloaded successfully.');
    // } catch (error) {
    //     console.error('Error generating image:', error);
    // }
  };

  return (
    <>
      <Header />
      <div className="flex">
        <div className="hidden lg:block bg-gradient-to-b from-[#0A142F] to-[#1B2A5E]">
          <Sidebar />
        </div>
        <main className="flex-1 p-2 sm:p-5 bg-gray-100">
          <h1 className="text-2xl sm:text-3xl lg:text-[46px] font-bold">
            Order History
          </h1>
          <p className="text-gray-500 mb-4 text-[12px] sm:text-[14px]">
            Dashboard / <span className="font-semibold">Order History</span>
          </p>

          {loading ? (
            <>
              <div className="mx-auto mt-4 sm:mt-10 py-[30px] sm:py-[50px] px-[10px] sm:px-[20px] bg-white">
                <Skeleton width="100%" />
              </div>
            </>
          ) : (
            <>
              <div className="mx-auto mt-4 sm:mt-10 py-[30px] sm:py-[50px] px-[10px] sm:px-[20px] bg-white overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 min-w-[600px]">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border border-[#E9ECEF] px-4 py-2 text-left text-[#6C757D] text-[12px] font-semibold">
                        Offer Name
                      </th>
                      <th className="border border-[#E9ECEF] px-4 py-2 text-left text-[#6C757D] text-[12px] font-semibold">
                        Coupon Code
                      </th>
                      <th className="border border-[#E9ECEF] px-4 py-2 text-left text-[#6C757D] text-[12px] font-semibold">
                        Claim Date
                      </th>
                      <th className="border border-[#E9ECEF] px-4 py-2 text-left text-[#6C757D] text-[12px] font-semibold">
                        Status
                      </th>
                      <th className="border border-[#E9ECEF] px-4 py-2 text-center text-[#6C757D] text-[12px] font-semibold">
                        Print Option
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderList.map((order, index) => (
                      <tr key={index} className="even:bg-gray-50">
                        <td className="border border-[##343A40] px-4 py-2 text-[14px] text-[#343A40] font-normal">
                          {order?.name}
                        </td>
                        <td className="border border-[##343A40] px-4 py-2 text-[14px] text-[#343A40] font-normal">
                          {order?.code}
                        </td>
                        <td className="border border-[##343A40] px-4 py-2 text-[14px] text-[#343A40] font-normal">
                          {order?.order_date}
                        </td>
                        <td className="border border-[##343A40] px-4 py-2 text-[14px] text-[#343A40] font-normal">
                          {order?.status}
                        </td>
                        <td className="border border-[##343A40] px-4 py-2 text-[14px] text-[#343A40] font-normal text-center">
                          <button
                            className="bg-gray-200 text-black px-4 py-1 rounded hover:bg-blue-600 hover:!text-white"
                            onClick={() => handleGenerateInvoice(order?.id)}
                          >
                            Print
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {loading2 && (
            <>
              <div className="absolute -top-[99999px] -left-[99999px] flex justify-center items-center">
                <div
                  ref={invoiceRef}
                  className="bg-white border border-gray-300 p-5 w-full max-w-3xl mx-auto"
                >
                  {/* Header Section */}
                  <div className="flex flex-col justify-center items-center mb-5">
                    <img
                      src={IMAGES.finalLogo}
                      alt="Logo"
                      className="w-[150px] max-w-full h-auto mb-2"
                    />
                  </div>

                  {/* Customer & Order Details */}
                  <div className="mb-5">
                    <table className="w-full text-sm">
                      <tbody>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Name:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.current_user}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Order Number:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.order_details?.order_number}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Order Date:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.order_details?.order_date}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Mobile:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.order_details?.mobile}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Email:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.order_details?.email}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1 font-medium text-gray-700">
                            Payment Method:
                          </td>
                          <td className="py-1 text-right text-gray-700">
                            {OrderDetailsOnID?.order_details?.payment_method}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Product Details */}
                  <div className="mb-5">
                    <h3 className="mb-3 text-base font-semibold text-gray-800">
                      Product Details
                    </h3>
                    <table className="w-full border-collapse border border-gray-300 text-sm">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-300 py-2 px-3 text-left min-w-64 max-w-72">
                            Product
                          </th>
                          <th className="border border-gray-300 py-2 px-3 text-right">
                            Price
                          </th>
                          <th className="border border-gray-300 py-2 px-3 text-right">
                            Quantity
                          </th>
                          <th className="border border-gray-300 py-2 px-3 text-right">
                            Subtotal
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-gray-300 py-2 px-3">
                            {OrderDetailsOnID?.order_details?.name}
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right">
                            ₹ {OrderDetailsOnID?.order_details?.prize}
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right">
                            {OrderDetailsOnID?.order_details?.qty}
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right">
                            ₹ {OrderDetailsOnID?.order_details?.subtotal}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            colSpan="3"
                            className="border border-gray-300 py-2 px-3 text-left"
                          >
                            SubTotal
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right">
                            ₹ {OrderDetailsOnID?.order_details?.subtotal}
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan="3"
                            className="border border-gray-300 py-2 px-3 text-left"
                          >
                            Discount
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right">
                            -₹ {OrderDetailsOnID?.order_details?.discount}
                          </td>
                        </tr>
                        <tr className="bg-gray-100">
                          <td
                            colSpan="3"
                            className="border border-gray-300 py-2 px-3 text-left font-bold"
                          >
                            Total
                          </td>
                          <td className="border border-gray-300 py-2 px-3 text-right font-bold">
                            ₹ {OrderDetailsOnID?.order_details?.total}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  {/* Footer Section */}
                  <div className="text-center mt-5 text-xs text-gray-500">
                    <p>Thank you for your business!</p>
                    <p>For support, contact support@bizprime.com</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Orders;

// {
//     OrderDetailsOnID && (
//         <>
//             <div ref={invoiceRef} className="bg-white border border-gray-300 p-5 w-full max-w-3xl mx-auto">
//                 {/* Header Section */}
//                 <div className="text-center mb-5">
//                     <h1 className="text-2xl font-bold text-gray-800">BizPrime</h1>
//                     <p className="text-sm text-gray-500">Invoice</p>
//                 </div>

//                 {/* Customer & Order Details */}
//                 <div className="mb-5">
//                     <table className="w-full text-sm">
//                         <tbody>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Name:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.current_user}</td>
//                             </tr>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Order Number:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.order_details?.order_number}</td>
//                             </tr>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Order Date:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.order_details?.order_date}</td>
//                             </tr>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Mobile:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.order_details?.mobile}</td>
//                             </tr>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Email:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.order_details?.email}</td>
//                             </tr>
//                             <tr>
//                                 <td className="py-1 font-medium text-gray-700">Payment Method:</td>
//                                 <td className="py-1 text-right text-gray-700">{OrderDetailsOnID?.order_details?.payment_method}</td>
//                             </tr>
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Product Details */}
//                 <div className="mb-5">
//                     <h3 className="mb-3 text-base font-semibold text-gray-800">Product Details</h3>
//                     <table className="w-full border-collapse border border-gray-300 text-sm">
//                         <thead>
//                             <tr className="bg-gray-100">
//                                 <th className="border border-gray-300 py-2 px-3 text-left">Product</th>
//                                 <th className="border border-gray-300 py-2 px-3 text-right">Price</th>
//                                 <th className="border border-gray-300 py-2 px-3 text-right">Quantity</th>
//                                 <th className="border border-gray-300 py-2 px-3 text-right">Subtotal</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             <tr>
//                                 <td className="border border-gray-300 py-2 px-3">{OrderDetailsOnID?.order_details?.name}</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right">₹ {OrderDetailsOnID?.order_details?.prize}</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right">{OrderDetailsOnID?.order_details?.qty}</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right">₹ {OrderDetailsOnID?.order_details?.subtotal}</td>
//                             </tr>
//                         </tbody>
//                         <tfoot>
//                             <tr>
//                                 <td colSpan="3" className="border border-gray-300 py-2 px-3 text-left">SubTotal</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right">₹ {OrderDetailsOnID?.order_details?.subtotal}</td>
//                             </tr>
//                             <tr>
//                                 <td colSpan="3" className="border border-gray-300 py-2 px-3 text-left">Discount</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right">-₹ {OrderDetailsOnID?.order_details?.discount}</td>
//                             </tr>
//                             <tr className="bg-gray-100">
//                                 <td colSpan="3" className="border border-gray-300 py-2 px-3 text-left font-bold">Total</td>
//                                 <td className="border border-gray-300 py-2 px-3 text-right font-bold">₹ {OrderDetailsOnID?.order_details?.total}</td>
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </div>

//                 {/* Footer Section */}
//                 <div className="text-center mt-5 text-xs text-gray-500">
//                     <p>Thank you for your business!</p>
//                     <p>For support, contact support@bizprime.com</p>
//                 </div>
//             </div>

//         </>
//     )
// }
